import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import CopyText from "../../CopyText/CopyText";
import Tooltip from "../../Tooltip/Tooltip";
import { Icon } from "../../Icon/Icon";
import printIcon from "../../../assets/images/printer.svg";

interface StoreCommissionPanelHeaderProps {
  shareLink: string;
  pdfUrl?: string | null;
  showRequestSummary?: boolean;
  onDownloadRequestSummary?: () => void;
  isDownloadingRequestSummary?: boolean;
}

export default function StoreCommissionPanelHeader({
  shareLink,
  pdfUrl,
  showRequestSummary = false,
  onDownloadRequestSummary,
  isDownloadingRequestSummary = false,
}: StoreCommissionPanelHeaderProps) {
  const { t } = useTranslation();
  const requestSummaryLabel =
    t("store_commission_panel.print_request_summary") || "Print request summary";

  return (
    <div className="flex flex-wrap items-center gap-3 mb-2">
      <CopyText text={shareLink} />
      <span className="text-xs text-muted-foreground mr-2">
        {t("store_commission_panel.share_with_customer") || "Share with the customer"}
      </span>
      {showRequestSummary && onDownloadRequestSummary && (
        <div className="ml-auto">
          <Tooltip content={requestSummaryLabel} position="bottom">
            <button
              type="button"
              onClick={onDownloadRequestSummary}
              disabled={isDownloadingRequestSummary}
              aria-label={requestSummaryLabel}
              className="p-1.5 rounded hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Icon url={printIcon} />
            </button>
          </Tooltip>
        </div>
      )}
      {pdfUrl && (
        <a
          href={pdfUrl}
          download
          className="flex items-center text-xs text-blue-600 underline hover:text-blue-800 gap-1"
        >
          <Download className="h-4 w-4" />
          {t("store_commission_panel.download_pdf_contract") || "Download PDF contract"}
        </a>
      )}
    </div>
  );
}
